import { Carousel } from './carousel';

export class PromoCarousel extends Carousel {
  /**
   * css selector of carousel container
   * @static
   */
  static selector = '.js-carousel';

  /**
   * Checks if container node is present in the dom
   * @function isOnPage
   * @returns {Boolean}
   * @static
   */
  static isOnPage() {
    return document.querySelector(PromoCarousel.selector);
  }

  constructor() {
    super();
    this.carousel = new Map();
    super.init(this, PromoCarousel.selector);
  }

  /**
   * Synchronizes the tabindex of slide links based on the presence of nested interactive elements.
   * @param {Node} carousel - DOM element of the carousel.
   */
  syncSlideTabindex = (carousel) => {
    $(carousel).find('.carousel-slide-link').each((index, el) => {
      const $box = $(el);
      const hasButton = $box.find('.carousel-btn').length > 0;
      const hasVideo = $box.find('.video-popup-image-wrapper-button').length > 0;

      $box.attr('tabindex', (hasButton || hasVideo) ? '-1' : '0');
    });
  }

  /**
   * Adds event listener for focus to activate the slide.
   * @param {Swiper} swiper - Swiper instance.
   * @param {Node} $carouselElement - DOM element of the carousel.
   */
  enableFocusSlideActivation(swiper, $carouselElement) {
    $carouselElement.addEventListener('focusin', (event) => {
      if (swiper.autoplay && swiper.autoplay.running) {
        const $playPauseBtn = $($carouselElement).find('.js-play-pause-box-btn');

        // Stop autoplay and sync UI state (icons/labels) when the carousel receives focus.
        if ($playPauseBtn.length > 0) {
          $playPauseBtn.trigger('click');
        } else {
          swiper.autoplay.stop();
        }
      }

      const slideElement = event.target.closest('.swiper-slide');

      if (slideElement && swiper && $carouselElement.contains(slideElement)) {
        const slideIndex = Array.from(swiper.slides).indexOf(slideElement);

        if (slideIndex > -1 && swiper.activeIndex !== slideIndex) {
          swiper.slideTo(slideIndex, 0);
        }

        // Reset native scroll position to prevent layout shifts caused by browser focus behavior.
        // This ensures that the pagination and other controls remain visible.
        setTimeout(() => {
          $carouselElement.scrollLeft = 0;
          $carouselElement.scrollTop = 0;
        }, 0);
      }
    }, { capture: true });
  }

  /**
   * Generate config depending of the number of the slides in carousel by extending the default config
   * @param {Node} $carousel - Carousel DOM Node
   * @returns {Object} extended config
   */
  generateConfig($carousel) {
    if (super.hasSingleSlide($carousel)) {
      return super.extendConfig({
        pagination: false,
        loop: false,
        autoplay: false,
        roundLengths: true
      });
    }

    return super.extendConfig({
      autoplay: super.toggleAutoplay($carousel),
      watchSlidesVisibility: true,
      spaceBetween: 10,
      loop: false,
      breakpoints: {
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30
        }
      },
      pagination: {
        el: $carousel.querySelector('.js-carousel-pagination'),
        clickable: true,
        type: 'bullets',
        renderBullet: (index, className) => {
          const controlsNav = $carousel.querySelector('.carousel-controls');
          const baseLabel = controlsNav?.getAttribute('data-aria-label') || 'Slide';

          return `<button class="${className}" aria-current="false" data-index="${index + 1}" aria-label="${baseLabel} ${index + 1}"></button>`;
        }
      },
      roundLengths: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        enabled: true,
      },
      on: {
        init: (swiper) => {
          const $pagination = $(swiper.pagination?.el);
          const $controlsNav = $(swiper.el).find('.carousel-controls');
          const baseLabel = $controlsNav.attr('data-aria-label') || 'Slide';

          if ($pagination.length) {
            $pagination.find('.swiper-pagination-bullet-active').attr('aria-current', 'true');
            $pagination.find('.swiper-pagination-bullet').each((index, el) => {
              const $bullet = $(el);
              const bulletIndex = $bullet.attr('data-index') || (index + 1);

              if (!$bullet.attr('aria-label')) {
                $bullet.attr('aria-label', `${baseLabel} ${bulletIndex}`);
              }
            });
          }

          this.syncSlideTabindex(swiper.el);
          this.enableFocusSlideActivation(swiper, swiper.el);
        },

        slideChange: (swiper) => {
          const $pagination = $(swiper.pagination?.el);

          if ($pagination.length) {
            $pagination.find('.swiper-pagination-bullet').each((index, el) => {
              const $bullet = $(el);
              const isActive = $bullet.hasClass('swiper-pagination-bullet-active');
              $bullet.attr('aria-current', isActive ? 'true' : 'false');
            });
          }
        }
      }
    });
  }
}